<div class="value-container" 
  [class.blue]='data?.is_checked' 
  [class.light]='!data?.is_checked' 
  [class.mw]='data?.radio_button' 
  >
  <div
    class="content pr-0"
    (click)='handleChecked(data, $event)'
    *ngIf="data?.value"
  >
    <div
      class="input-container custom-control"
      [ngClass]="data?.radio_button ? 'custom-radio' : 'custom-checkbox'"
      >
      <input 
        [type]="data?.radio_button ? 'radio' : 'checkbox'"
        class="custom-control-input"
        id="privateMode-{{cellIndex}}-{{tableIndex}}"
        [checked]='data.is_checked'
      >
      <label class="custom-control-label" for="privateMode-{{cellIndex}}-{{tableIndex}}">
        <span class="checkbox-label">{{data.value | truncate : data.nDecimals}}</span>
      </label>
    </div>
  </div>
  <span
    class="content pl-0"
    (click)="openCellManualEdit()"
    *ngIf="data?.cell_type === 'cella_edit_true_false'"
    [class.show]="data?.value"
    [class.insert-value]="!data?.value"
  >
    {{ data?.value ? '(edit)' : 'Insert value' }}
  </span>
</div>
